import { render, staticRenderFns } from "./UpcomingArrivalsView.vue?vue&type=template&id=90607b12&"
import script from "./UpcomingArrivalsView.vue?vue&type=script&lang=js&"
export * from "./UpcomingArrivalsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports